import { useSelector } from 'react-redux'

import { selectCurrentVariantCohort } from 'root-redux/selects/common'

import {
  CHECKOUT_PAYMENT_PRIORITY_BY_COHORT,
  PAYWALL_GOOGLE_PAY_DISABLED_COHORTS,
} from 'modules/purchase/constants/paymentPreferences'

export const usePaymentPreferences = () => {
  const cohort = useSelector(selectCurrentVariantCohort)

  return {
    isGooglePayHiddenOnPaywall:
      PAYWALL_GOOGLE_PAY_DISABLED_COHORTS.includes(cohort),
    checkoutPaymentPriority: CHECKOUT_PAYMENT_PRIORITY_BY_COHORT[cohort],
  }
}
